export const TONES = [
  { id: "auto", label: "Auto clean" },
  { id: "formal", label: "Formal" },
  { id: "casual", label: "Casual" },
  { id: "email", label: "Email" },
  { id: "verbatim", label: "Verbatim" },
];

export const MODELS = [
  { id: "sonnet", label: "Claude Sonnet 5.5", hint: "Balanced everyday polish" },
  { id: "opus", label: "Claude Opus 5.5", hint: "Deepest rewriting quality" },
  { id: "luna", label: "GPT 6 Luna", hint: "Fastest turnaround" },
];

export const toneLabel = (id) => TONES.find((t) => t.id === id)?.label || (id ? id[0].toUpperCase() + id.slice(1) : id);
